import { useEffect, useState } from "react";
import { elegirVoz } from "../../../dominio/src/index.ts";
import { leerAjustes, guardarAjustes, hablar, callar, soportaHabla, vocesEspanolDelEquipo, type AjustesVoz } from "../habla.ts";
import { resumenDeHoy } from "../resumenDia.ts";

/** Ajustes de la voz de Donna (valen para este equipo y este navegador, porque las voces cambian de un equipo a otro). */
export function VozDeDonna() {
  const [a, setA] = useState<AjustesVoz>(leerAjustes);
  const [voces, setVoces] = useState<SpeechSynthesisVoice[]>([]);
  const [aviso, setAviso] = useState("");
  useEffect(() => { vocesEspanolDelEquipo().then(setVoces); }, []);
  if (!soportaHabla()) return <p className="muted" style={{ margin: 0 }}>Este navegador no puede hablar. Prueba con Chrome, Edge o Safari actualizados.</p>;
  const cambiar = (p: Partial<AjustesVoz>) => setA(guardarAjustes(p));
  const mejor = elegirVoz(voces, a.voz);
  async function probar() {
    setAviso("");
    const dijo = await hablar("Hola, soy Donna. Estoy aquí para ayudarte con tu consulta: la agenda, tus pacientes y lo que necesites. Cuenta conmigo.", { forzar: true, ajustes: leerAjustes() });
    if (!dijo) setAviso("No pude hablar. Revisa que el volumen esté encendido y que este equipo tenga una voz en español instalada.");
  }
  return (
    <div style={{ display: "grid", gap: 10 }}>
      <p className="muted" style={{ margin: 0, fontSize: 13 }}>Donna responde en voz alta cuando usas «Hola Donna». Usa la voz de este equipo: no se envía nada a internet para hablar.</p>
      <label style={{ display: "flex", gap: 8, alignItems: "center" }}><input type="checkbox" checked={a.habla} onChange={(e) => { cambiar({ habla: e.target.checked }); if (!e.target.checked) callar(); }} /> Donna habla en voz alta</label>
      <label style={{ display: "flex", gap: 8, alignItems: "center" }}><input type="checkbox" checked={a.discreto} onChange={(e) => cambiar({ discreto: e.target.checked })} /> <span><b>Modo discreto</b> (recomendado): no dice nombres de pacientes en voz alta</span></label>
      <label style={{ display: "flex", gap: 8, alignItems: "center" }}><input type="checkbox" checked={a.saludar} onChange={(e) => cambiar({ saludar: e.target.checked })} /> Saludarme y contarme cómo va mi día al entrar (una vez al día)</label>
      <div className="fila" style={{ flexWrap: "wrap", gap: 12 }}>
        <label className="campo" style={{ flex: "2 1 260px" }}>Voz
          <select value={a.voz} onChange={(e) => cambiar({ voz: e.target.value })}>
            <option value="">Automática{mejor ? ` (${mejor.name})` : ""}</option>
            {voces.map((v) => <option key={v.name} value={v.name}>{v.name} · {v.lang}</option>)}
          </select>
        </label>
        <label className="campo" style={{ flex: "1 1 140px" }}>Velocidad
          <input type="range" min="0.7" max="1.3" step="0.05" value={a.velocidad} onChange={(e) => cambiar({ velocidad: Number(e.target.value) })} />
        </label>
        <label className="campo" style={{ flex: "1 1 140px" }}>Tono
          <input type="range" min="0.8" max="1.4" step="0.05" value={a.tono} onChange={(e) => cambiar({ tono: Number(e.target.value) })} />
        </label>
      </div>
      {voces.length === 0 && <div className="aviso info">Este equipo no tiene voces en español instaladas. En Windows: Configuración → Hora e idioma → Voz → Agregar voces. En Edge hay voces «Natural» muy buenas.</div>}
      <div className="fila" style={{ flexWrap: "wrap" }}>
        <button className="btn" onClick={probar}>Probar la voz</button>
        <button className="btn" onClick={() => { setAviso(""); resumenDeHoy().then((t) => { setAviso(t); void hablar(t, { forzar: true, ajustes: leerAjustes() }); }).catch(() => setAviso("No pude leer tu agenda.")); }}>Escuchar el resumen de mi día</button>
        <button className="btn" onClick={callar}>Callar</button>
      </div>
      {aviso && <div className="aviso info" role="status">{aviso}</div>}
    </div>
  );
}

